import {
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WhiteButton } from '../ui/Button';
import LoadingButton from '../ui/LoadingButton';

interface TransformToCNCProps {
  isTransformedToCNC: string;
  setIsTransformedToCNC: (value: string) => void;
  onClose: () => void;
  onNext: () => void;
}

const TransformToCNC = ({
  isTransformedToCNC,
  setIsTransformedToCNC,
  onClose,
  onNext,
}: TransformToCNCProps) => {
  const { t } = useTranslation(['common', 'cnc-reports']);
  return (
    <>
      <RadioGroup
        value={isTransformedToCNC}
        onChange={(e) => setIsTransformedToCNC(e.target.value)}
      >
        <FormControlLabel
          value="yes"
          control={<Radio />}
          label={t('common:yes')}
        />
        <FormControlLabel
          value="no"
          control={<Radio />}
          label={t('common:no')}
        />
      </RadioGroup>
      <DialogActions>
        <WhiteButton onClick={onClose}>{t('common:cancel')}</WhiteButton>
        <LoadingButton
          onClick={onNext}
          color="primary"
          disabled={!isTransformedToCNC}
        >
          {t('common:next')}
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default TransformToCNC;
